module.exports = __webpack_public_path__ + "static/logo-fa39acec23b090f27954852243945a22.png";